import { Component, Prop, Vue } from "vue-property-decorator";
import { Module, TTMJ } from "@/store/enums.ts";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import AudioHandler from "./Recorder";
import { fetchAllItemsURL, submitFiles } from "./StorageHandler";
import firebase from "firebase/app";
import UUID from "uuid/v1";
import { taskCompleted } from "./utils";

enum PICTURE_STORY_STATE {
  DESCRIPTION,
  FIRST_STORY
}

@Component
export default class TalkToMeJrPicStory extends Vue {
  private _frame: PICTURE_STORY_STATE;
  private _displayMessage: boolean;
  private _timeout: number = 3000;
  private _enableNext: boolean = false;
  private _enableDescribeNext: boolean = false;
  private _data: { imgLink: string; name: string }[] = [];
  private _blob?: any;
  private audioLoc =
    "/res/protected/t2mejr_instructions/ttmj_pic_stories_autoplay.mp3";

  constructor() {
    super();
    this._frame = PICTURE_STORY_STATE.DESCRIPTION;
    this._displayMessage = false;
  }

  created() {
    this._enableDescribeNext = false;
    this.$store.dispatch("setClip", {
      path: this.audioLoc,
      callbackFunction: () => {
        this._enableDescribeNext = true;
        this.$forceUpdate();
      }
    });
    this.$forceUpdate();
    this._frame = PICTURE_STORY_STATE.DESCRIPTION;
    this._displayMessage = false;
    this._data = [];
    this._getData();
  }

  beforeDestroy() {
    this.$store.dispatch("removeClip", this.audioLoc);
  }

  render(h: CreateElement) {
    return (
      <span>
        {this._task()} {this._describeTask()}
      </span>
    );
  }

  private async _getData() {
    let data: any = await fetchAllItemsURL("res/protected/picture_story");
    data.map((i: any, idx: any) =>
      this._data.push({ imgLink: i, name: "Picture " + idx + 1 })
    );
  }

  private _describeTask() {
    return (
      this._frame === PICTURE_STORY_STATE.DESCRIPTION && (
        <Card title="I can tell stories from pictures." mod={Module.TTMJ}>
          <div slot="mainContent">
            In this task you will see six pictures. The pictures tell a story.
            Try to describe what is going on. Try to use full sentences when you
            tell the story. Click "Next" when you are ready.
          </div>
          <div slot="actions">
            <v-btn
              color="warning"
              onClick={(e: any) => {
                this._frame = PICTURE_STORY_STATE.FIRST_STORY;
                this.$forceUpdate();
              }}
              disabled={!this._enableDescribeNext}
            >
              Next
            </v-btn>
          </div>
        </Card>
      )
    );
  }

  private _task() {
    let tasks = (item: { imgLink: string; name: string }) => {
      return (
        <v-col cols="12" sm="4">
          <v-card class="mx-auto text-center" max-width="300">
            <v-img src={item.imgLink} />
            {/* <v-card-title
							class='mx-auto'
							style={{
								fontSize: '14px',
								margin: `0 0 0 10px`,
								padding: `0 10px 0 14px`,
							}}
						>
							{item.name}
						</v-card-title> */}
          </v-card>
        </v-col>
      );
    };

    let taskItem = this._data;

    const elements = taskItem.map(e => tasks(e));
    return (
      this._frame === PICTURE_STORY_STATE.FIRST_STORY && (
        <Card title="Tell a story from the pictures." mod={Module.TTMJ}>
          <div slot="mainContent">
            <v-col class="mx-auto text-center" cols={16}>
              <AudioHandler
                recordID="ps"
                label={{
                  start: "Start Recording",
                  end: "Stop Recording"
                }}
                allowOneUsage
                disableUserControl
                callbackOnStop={this._recordingStopped}
              />
            </v-col>
            <p class="subtitle-2">
              There are six pictures below. The pictures tell a story. Click
              "Start Recording" and then describe what is happening in the
              pictures. Try to use full sentences when you tell the story. Click
              "Next" when you are done.
            </p>
            <v-container fluid>
              <v-row dense>{elements}</v-row>
            </v-container>
          </div>

          <div slot="actions">
            <v-row class="mx-auto text-center">
              <v-col cols={8}>
                <v-btn
                  disabled={!this._enableNext}
                  onclick={async () => {
                    let currentUser = firebase.auth().currentUser;
                    if (!currentUser) return;

                    let dir =
                      "users/" +
                      currentUser.uid +
                      "/t2mejr/picture_story/pic_story.webm";

                    let uid = UUID();
                    this.$store.dispatch("addNotification", {
                      type: "info",
                      value: "Please wait while we upload your answers",
                      timeout: -1,
                      icon: "mdi-voice",
                      uid: uid,
                      loaderValue: 0
                    });
                    await submitFiles(dir, this._blob, (snapshot: any) => {
                      let progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                      this.$store.dispatch("updateVisibleNotification", {
                        value:
                          progress < 99
                            ? "Please wait while we upload your answer"
                            : "Successfully updated",
                        type: progress < 99 ? "info" : "success",
                        icon: "mdi-microphone",
                        uid: uid,
                        loaderValue: progress,
                        timeout: progress < 99 ? -1 : 4000
                      });

                      // set task completed in firestore
                      if (snapshot.bytesTransferred == snapshot.totalBytes) {
                        if (!currentUser) return;
                        taskCompleted(currentUser.uid, TTMJ.PICTURE);
                      }
                    });

                    this.$router.push({
                      name: "t2mejr-tasklist"
                    });
                  }}
                >
                  Next
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </Card>
      )
    );
  }

  private _recordingStopped(audio: any, duration: any, blob?: any) {
    this._displayMessage = true;
    this._enableNext = true;

    this._blob = blob;

    this.$forceUpdate();
  }
}

const component = TalkToMeJrPicStory;
